import clsx from 'clsx'
import React, { useState } from 'react'

import { Icon } from '@wartek-id/icon'
import { Text } from '@wartek-id/text'

import { removeTagsStyleAttribute } from 'utils/text'
import { sanitize } from 'utils/text'

import styles from './TopicSpeedDropdown.module.css'

interface Props {
  genericInfo: string
  aksiNyata: string
  pelajariSemuaModul: string
  rekomendasiPenyelesaianTopik: string
}

const TopicSpeedDropdown = ({
  genericInfo,
  aksiNyata,
  pelajariSemuaModul,
  rekomendasiPenyelesaianTopik,
}: Props) => {
  const [expanded, setExpanded] = useState(false)

  return (
    <article className={clsx('flex flex-col bg-white overflow-hidden')}>
      <header
        className="flex items-center p-[14px]"
        onClick={() => setExpanded(!expanded)}
      >
        <Icon fontSize="sm">info_outlined</Icon>
        <Text variant="helper-bold" className="flex-1 ml-[14px]">
          Rekomendasi penyelesaian topik: {rekomendasiPenyelesaianTopik}
        </Text>
        <button
          className={clsx(
            'flex items-center',
            styles.button,
            expanded && 'rotate-180'
          )}
        >
          <Icon fontSize="sm">keyboard_arrow_down</Icon>
        </button>
      </header>
      <section
        className={clsx(
          'px-4 pt-0',
          expanded ? styles['section-expanded'] : styles['section-collapsed']
        )}
      >
        <Text
          variant="body-sm"
          dangerouslySetInnerHTML={{
            __html: removeTagsStyleAttribute(sanitize(genericInfo)),
          }}
        />
        <Text as="div" variant="body-sm">
          <ol className="list-decimal pl-4">
            <li>Pelajari semua modul ({pelajariSemuaModul})</li>
            <li>Melakukan aksi nyata ({aksiNyata})</li>
          </ol>
        </Text>
      </section>
    </article>
  )
}

export default TopicSpeedDropdown
